export enum AuthRole {
    EXT = 'EXT',
    AUDITOR = 'AUDITOR',
    EXT_AUDITOR = 'EXT_AUDITOR',
    MANAGER = 'MANAGER',
    EO = 'EO',
    GBO = 'GBO'
}
